import Vue from 'vue'
import store from '../store/index'
import { buildSummarizeReportsReviewPayload} from '@/util/payloadBuilders/summarizePayloadBuilder'


const getDefaultReportState = () => {
  return {
    overall: [],
    stack: [],
    groupBy: { name: 'Product', id: 'product' },
    overallAvgCsat: 0,
    overallRecommendationScore: 0,
    compareRatingOverRecommendation: [],
    sortingArray: [],
    timePeriodGroupBy: 'quarter',
    lastViewedChart: {
      type: 'line',
      active: 'selectLine'
    },
    summarizeReportsReviewData : null,
    summarizeLoading: false,
    

    summarizeReviewsOverTimeData: null,
    summarizeRatingOverTimeData: null,
    summarizeRecommendationOverTimeData: null,
    summarizeRatingVsRecommendationData: null,

    summarizeReviewsOverTimeLoading :false,
    summarizeRatingOverTimeLoading :false,
    summarizeRecommendationOverTimeLoading :false,
    summarizeRatingVsRecommendationLoading : false

  }
}

export default {
  namespaced: true,
  state: getDefaultReportState(),
  actions: {
    /** This method gets the data required to render the rating and recommendation % over time reports as well as the reviews over time reports */
    getReport ({ commit, state }, value) {
      Vue.prototype.$http.post('/report/getReviewsOverTime', value).then((response) => {
        if (response.data.status === 200 && response.data.data && value.module === 'voc') {
          commit('SET_REVIEWS_OVER_TIME_RAW', response.data.data)
          commit('REPORT_STACK', response.data.data.stack)
          commit('OVERALL_AVG_CSAT', response.data.data.overallAverageCsat)
          commit('OVERALL_AVG_RECOMMENDATION_SCORE', response.data.data.overallRecommendationScore)
          commit('COMPARE_RATING_OVER_RECOMMENDATION', response.data.data.compareRatingOverRecommendation
            .map(d => {
              d.x = d.csat_rating
              d.y = d.recommendation_score
              d.volume = d.review_volume
              return d
            }))
        } else if (response.data.status === 200 && response.data.data && value.module === 'voe') {
          commit('REPORT_STACK', response.data.data.stack)
          commit('OVERALL_AVG_CSAT', response.data.data.overallAverageCsat)
        }
      }).catch(e => {
        commit('LOADING', false)
      })
    },
    /** This method gets the data required to render the horizontal bar chart */
    getGroupedReport ({ commit }, value) {
      Vue.prototype.$http.post('/report/getReviewSplit', value).then((response) => {
        if (response.data.status === 200 && response.data.data) {
          commit('REPORT_OVERALL', response.data.data)
          if (value.groupBy === 'product') {
            commit('REPORT_SORTING_ARRAY', response.data.data)
          }
        }
        commit('LOADING', false)
      }).catch(e => {
        commit('LOADING', false)
      })
    },
    /** This method updates the grouping criteria for the Horizontal bar chart on the Reports page */
    updateGroupBy ({ commit }, value) {
      commit('GROUP_BY', value)
    },
    resetReportState ({ commit }, value) {
      commit('RESET_REPORT_STATE')
    },
    /** This method saves the last viewed Reviews over time chart */
    updateLastViewedChart ({ commit }, value) {
      commit('UPDATE_LAST_VIEWED_CHART', value)
    },

     /** This method gets the data required to summarize report reviews */
    getSummarizeReportsReviews ({ commit, state, dispatch }, groupBy) {
          commit('SUMMARIZE_LOADING', true)

          const payload = buildSummarizeReportsReviewPayload(groupBy,state.overall)

          Vue.prototype.$http.post('/voc/summarize-filter-view', payload)
            .then((response) => {
              if (response.data.status === 200) {
                if (response.data && response.data.data) {
                  commit('SET_SUMMARIZE_REPORTS_REVIEWS_DATA', response.data.data)
                  dispatch('client/getVocAiUsage', null, { root: true })
                }
              } else {
                commit('SET_SUMMARIZE_REPORTS_REVIEWS_DATA', {summary : 'Unable to generate insights at the moment. Please try again later.'})
              }
              commit('SUMMARIZE_LOADING', false)
            })
            .catch((error) => {
              commit('SUMMARIZE_LOADING', false)
              commit('SET_SUMMARIZE_REPORTS_REVIEWS_DATA', {summary : 'Unable to generate insights at the moment. Please try again later.'})
            })
        },

     /** This method gets the data required to summarize reviews/ratings/recommendation over time and Compare Rating vs Recommendation % chart*/
    getSummarizeRatingReviewRecommendation ({ commit, state, dispatch }, type) {

      if (type === 'csat_rating'){
        commit('RATING_OVER_TIME_LOADING', true)
      } else if(type === 'recommendation_score'){
        commit('RECOMMENDATION_OVER_TIME_LOADING', true)
      } else if(type === 'rating_vs_recommendation'){
        commit('RATING_VS_RECOMMENDATION_LOADING', true)
      } else {
        commit('REVIEWS_OVER_TIME_LOADING', true)
      }

      const payload = state.reviewsOverTimeRaw || {}

       Vue.prototype.$http.post('/voc/summarize-rating-review-recommendation', payload)
            .then((response) => {
              if (response.data.status === 200) {
                if (response.data && response.data.data) {
                  dispatch('client/getVocAiUsage', null, { root: true })
                  if (type === 'csat_rating'){
                    commit('SET_SUMMARIZE_RATING_OVER_TIME', response.data.data.rating_over_time)
                  } else if(type === 'recommendation_score'){
                    commit('SET_SUMMARIZE_RECOMMENDATION_OVER_TIME', response.data.data.recommendation_over_time)
                  } else if(type === 'rating_vs_recommendation'){
                    commit('SET_SUMMARIZE_RATING_VS_RECOMMENDATION', response.data.data.rating_vs_recommendation)
                  } else {
                    commit('SET_SUMMARIZE_REVIEWS_OVER_TIME', response.data.data.reviews_over_time)
                  }
                }
              } else {
                  if (type === 'csat_rating'){
                    commit('SET_SUMMARIZE_RATING_OVER_TIME', {summary : 'Unable to generate insights at the moment. Please try again later.'})
                  } else if(type === 'recommendation_score'){
                    commit('SET_SUMMARIZE_RECOMMENDATION_OVER_TIME', {summary : 'Unable to generate insights at the moment. Please try again later.'})
                  } else if(type === 'rating_vs_recommendation'){
                    commit('SET_SUMMARIZE_RATING_VS_RECOMMENDATION', {summary : 'Unable to generate insights at the moment. Please try again later.'})
                  } else {
                    commit('SET_SUMMARIZE_REVIEWS_OVER_TIME',{summary : 'Unable to generate insights at the moment. Please try again later.'})
                  }
              }
                if (type === 'csat_rating'){
                    commit('RATING_OVER_TIME_LOADING', false)
                  } else if(type === 'recommendation_score'){
                    commit('RECOMMENDATION_OVER_TIME_LOADING', false)
                  } else if(type === 'rating_vs_recommendation'){
                    commit('RATING_VS_RECOMMENDATION_LOADING', false)
                  } else {
                    commit('REVIEWS_OVER_TIME_LOADING',false)
                  }
            })
            .catch((error) => {
              commit('REVIEWS_OVER_TIME_LOADING', false)
              commit('RATING_OVER_TIME_LOADING', false)
              commit('RECOMMENDATION_OVER_TIME_LOADING', false)
              commit('RATING_VS_RECOMMENDATION_LOADING', false)
              commit('SET_SUMMARIZE_REVIEWS_OVER_TIME', {summary : 'Unable to generate insights at the moment. Please try again later.'})
              commit('SET_SUMMARIZE_RATING_OVER_TIME', {summary : 'Unable to generate insights at the moment. Please try again later.'})
              commit('SET_SUMMARIZE_RECOMMENDATION_OVER_TIME', {summary : 'Unable to generate insights at the moment. Please try again later.'})
              commit('SET_SUMMARIZE_RATING_VS_RECOMMENDATION', {summary : 'Unable to generate insights at the moment. Please try again later.'})
            })
        }
  },
  mutations: {
    REPORT_OVERALL (state, payload) {
      state.overall = payload.sort((a, b) => {
        if ((a.product_name === 'Others') !== (b.product_name === 'Others')) {
          return a.product_name === 'Others' ? 1 : -1
        }
        if ((a.company_name === 'Others') !== (b.company_name === 'Others')) {
          return a.company_name === 'Others' ? 1 : -1
        }
        return Number(b.review_volume) - Number(a.review_volume)
      })
    },
    LOADING (state, payload) {
      store.state.filters.loading = payload
    },
    REPORT_STACK (state, payload) {
      state.stack = payload
    },
    COMPARE_RATING_OVER_RECOMMENDATION (state, payload) {
      state.compareRatingOverRecommendation = payload
    },
    GROUP_BY (state, payload) {
      state.groupBy = payload
    },
    OVERALL_AVG_CSAT (state, payload) {
      state.overallAvgCsat = payload
    },
    OVERALL_AVG_RECOMMENDATION_SCORE (state, payload) {
      state.overallRecommendationScore = payload
    },
    REPORT_SORTING_ARRAY (state, payload) {
      state.sortingArray = payload.map(e => e.company_name)
    },
    RESET_REPORT_STATE (state, payload) {
      state = {} // getDefaultReportState()
    },
    UPDATE_LAST_VIEWED_CHART (state, payload) {
      state.lastViewedChart.type = payload
      if (payload === 'line') { state.lastViewedChart.active = 'selectLine' } else { state.lastViewedChart.active = 'selectStack' }
    },
    SUMMARIZE_LOADING (state, payload) {
      state.summarizeLoading = payload
    },
    SET_SUMMARIZE_REPORTS_REVIEWS_DATA (state, payload) {
      state.summarizeReportsReviewData = payload
    },
    REVIEWS_OVER_TIME_LOADING (state, payload) {
      state.summarizeReviewsOverTimeLoading = payload
    },
    RATING_OVER_TIME_LOADING (state, payload) {
      state.summarizeRatingOverTimeLoading = payload
    },
    RECOMMENDATION_OVER_TIME_LOADING (state, payload) {
      state.summarizeRecommendationOverTimeLoading = payload
    },
    RATING_VS_RECOMMENDATION_LOADING (state, payload) {
      state.summarizeRatingVsRecommendationLoading = payload
    },
    SET_SUMMARIZE_REVIEWS_OVER_TIME (state, payload) {
      state.summarizeReviewsOverTimeData = payload
    },
    SET_SUMMARIZE_RATING_OVER_TIME (state, payload) {
      state.summarizeRatingOverTimeData = payload
    },
    SET_SUMMARIZE_RECOMMENDATION_OVER_TIME (state, payload) {
      state.summarizeRecommendationOverTimeData = payload
    },
    SET_SUMMARIZE_RATING_VS_RECOMMENDATION (state, payload) {
      state.summarizeRatingVsRecommendationData = payload
    },
    SET_REVIEWS_OVER_TIME_RAW(state, payload) {
      state.reviewsOverTimeRaw = payload
    }
  }
}
